module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"modal.cancel_button":"Нет","modal.confirm_button":"Да","modal.warning_title":"Предупреждение","modal.warning_text::delete":"Уведомление будет удалено без возможности восстановления. Продолжить?"},"en":{"modal.warning_title":"Warning","modal.warning_text::delete":"The notification will be deleted permanently. Continue?","modal.confirm_button":"Yes","modal.cancel_button":"No"}}')
  delete Component.options._Ctor
}
